import { HttpClient } from "../../services/api/httpclient.service";


export class NewExerciseService extends HttpClient {
    constructor() {
        super();
    }

    public async searchExerciseInAzure(page: number, pageSize: number, search?: string) {
        try {
        const body = {
            page,
            page_size: pageSize,
            ...(search ? { search } : {}),
        };

        const response = await this.post('/data/search_exercise_in_azure', body);
        return await response;
        } catch (error) {
        console.error("Error searching exercises in Azure:", error);
        return { results: [], total: 0 };
        }
    }

    public async renameExerciseName(oldFilename: string, newFilename: string) {
        try {
            return await this.post('/data/rename_exercise_name', { old_filename: oldFilename, new_filename: newFilename });
        } catch (error) {
            console.error("Error renaming exercise:", error);
            throw error;
        }
    }

    public async downloadExerciseFromAzure(filename: string, exerciseId: number) {
        try {
          return await this.post('/data/download_exercise_from_azure', { "filename": filename, "exercise_id": exerciseId }, { responseType: 'blob' });
        } catch (error) {
          console.error("Error downloading exercise from Azure:", error);
          throw error;
        }
    }

    public async loadExerciseToDB(filename: string) {
        try {
          return await this.get(`/data/extract-all-docx/?filename=${encodeURIComponent(filename)}`);
        } catch (error) {
          console.error("Error loading exercise from Azure to db:", error);
          throw error;
        }
    }

    public async loadExerciseToDBV1(filename: string) {
      try {
        return await this.get(`/data/extract-all-docx_V1/?filename=${encodeURIComponent(filename)}`);
      } catch (error) {
        console.error("Error loading exercise from Azure to db:", error);
        throw error;
      }
  }

    public async deleteExerciseFromAzure(filename: string) {
        try {
          return await this.post('/data/delete_exercise_from_azure', { "filename": filename });
        } catch (error) {
          console.error("Error deleting exercise from Azure:", error);
          throw error;
        }
    }

    public async uploadExercisesToAzure(files: File[]) {
      const formData = new FormData();
      files.forEach(file => formData.append('files', file));
      try {
        const response = await this.post('/data/upload_exercises_to_azure', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response;
      } catch (error) {
        console.error("Error deleting exercise from Azure:", error);
        throw error;
      }
  }
}
